// libs
import React, { memo, useContext } from 'react';

// contexts
import { useAuthModalWrapperContext } from 'shared/components/AuthModal/AuthModalWrapperContext';
import { SubNavContext } from 'shared/components/SubNav';

// constants
import { TEXTS } from 'shared/components/Header/DesktopHeaderV2/components/HeaderActions/components/Auth/constants';

// styles
import { MenuItemWrapper } from 'shared/components/Header/DesktopHeaderV2/components/HeaderActions/components/Auth/components/LoggedIn/styles';
import { LINKS } from 'shared/components/MyAccount/constants';

function NotLoggedIn() {
  const { doHide } = useContext(SubNavContext);
  const { passiveShowAuthModal, showAuthModal } = useAuthModalWrapperContext();

  const showModal = () => {
    showAuthModal();
    doHide();
  };
  const loginRedirectOrders = () => {
    passiveShowAuthModal(LINKS.MY_ORDERS);
    doHide();
  };

  return (
    <MenuItemWrapper>
      <p className="sub-menu__text">{TEXTS.MESSAGE}</p>

      <button onClick={showModal} className="sub-menu__login ">
        {TEXTS.LOGIN_NOW}
        <i className="icon icon-arrow-next" />
      </button>

      <button
        onClick={loginRedirectOrders}
        className="sub-menu__menu-item border-bottom border-top "
      >
        {TEXTS.ORDERS}
        <i className="icon icon-orders" />
      </button>
    </MenuItemWrapper>
  );
}

export default memo(NotLoggedIn);
